<template>
    <div>
        <el-page-header class="page-header" @back="goBack" content="发布商品">
        </el-page-header>
        <el-form ref="goodsForm" :model="goodsForm" label-position="top" :rules="goodsFormRules">
            <div class="goods_form-item">
                <el-form-item label="商品名称" prop="name">
                    <el-input v-model="goodsForm.name" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="商品分类" prop="categoryId">
                    <el-cascader ref="categoryCascader" clearable v-model="goodsForm.categoryId" :props="cascaderProps"
                        style="width: 100%;" :options="cascaderData"></el-cascader>
                </el-form-item>
            </div>
            <div class="goods_form-item">
                <el-form-item label="商品封面图" prop="thumb">
                    <ImageUpload :image-url="goodsForm.thumb" @upload-success="handleImgUpload(1, $event)"
                        :max-files="1" />
                </el-form-item>
                <el-form-item label="商品轮播图" prop="images">
                    <ImageUpload :image-url="goodsForm.images" :max-files="6"
                        @upload-success="handleImgUpload(2, $event)" />
                </el-form-item>
            </div>
            <el-form-item label="商品详情" prop="body">
                <quill-editor v-model="goodsForm.body" ref="myQuillEditor" :options="editorOptions" />
            </el-form-item>
            <el-form-item label="商品证书" prop="product_certificate">
                <ImageUpload :image-url="goodsForm.product_certificate" :max-files="1"
                    @upload-success="handleImgUpload(3, $event)" />
            </el-form-item>
            <div class="goods_form-item">
                <el-form-item label="分类" prop="classification">
                    <el-select v-model="goodsForm.classification" placeholder="请选择" style="width: 100%;">
                        <el-option label="批发" value="1"></el-option>
                        <el-option label="严选" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品单位" prop="unit">
                    <el-input v-model="goodsForm.unit" placeholder="请输入"></el-input>
                </el-form-item>
            </div>
            <el-form-item label="商品规格" prop="spec">
                <el-table :data="goodsForm.spec" :border="true" style="width: 100%">
                    <el-table-column prop="key_name" label="规格名称" width="200" align="center">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.key_name" placeholder="请填写"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="min_buy_num" label="起批量" width="200" align="center">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.min_buy_num" placeholder="请填写"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="shop_price" label="单价（元）" width="200" align="center">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.shop_price" placeholder="请填写"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="stock" label="库存量" width="200" align="center">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.stock" placeholder="请填写"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column width="200" align="center">
                        <template slot="header">
                            <el-button type="primary" size="small" @click="addSpecRow">添加规格</el-button>
                        </template>
                        <template slot-scope="scope">
                            <el-button type="text" @click="moveDown(scope.$index)"
                                :disabled="scope.$index === goodsForm.spec.length - 1" style="color: #409EFF">
                                下移
                            </el-button>
                            <el-button type="text" @click="delFun(scope.$index)" style="color: #F56C6C">删除</el-button>
                            <el-switch v-model="scope.row.status" active-color="#13ce66" inactive-color="#ff4949"
                                :active-value="1" :inactive-value="0" active-text="启用" inactive-text="停用">
                            </el-switch>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form-item>
            <div class="goods_form-item">
                <el-form-item label="发货地" prop="delivery_address">
                    <div @click="mapPickerVisible = true">
                        <el-input v-model="goodsForm.delivery_address" placeholder="请输入" readonly></el-input>
                    </div>
                </el-form-item>
                <el-form-item label="总库存">
                    <el-input v-model="computedTotalStock" placeholder="请输入" disabled></el-input>
                </el-form-item>
            </div>
            <div class="goods_form-item">
                <el-form-item label="是否包邮" prop="is_shipping">
                    <el-select v-model="goodsForm.is_shipping" placeholder="请选择" style="width: 100%;">
                        <el-option label="包邮" value="1"></el-option>
                        <el-option label="不包邮" value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="运费模板" prop="freight_template_id" v-if="goodsForm.is_shipping == '0'">
                    <el-select v-model="goodsForm.freight_template_id" placeholder="请选择" style="width: 100%;">
                        <el-option v-for="item in freightList" :key="item.aid" :label="item.name"
                            :value="item.aid"></el-option>
                    </el-select>
                </el-form-item>
            </div>
            <el-form-item style="display: flex; justify-content: center;">
                <el-button type="primary" @click="submitForm">提交审核</el-button>
            </el-form-item>
        </el-form>
        <el-dialog title="地图选点" :visible.sync="mapPickerVisible" width="80%" height="80vh"
            :before-close="handleMapPickerClose" :close-on-click-modal="false">
            <MapPicker ref="mapPicker" @pointConfirmed="handleMapConfirm" :center="shopLngLat" />
        </el-dialog>
    </div>
</template>
<script>
import MapPicker from '@/components/MapPicker.vue'
import ImageUpload from '@/components/ImageUpload.vue'
import { quillEditor } from 'vue-quill-editor'
export default {
    name: 'AddProduct',
    components: {
        ImageUpload,
        quillEditor,
        MapPicker
    },
    props: {
        goods_id: {
            type: [String, Number],
            default: ''
        },
        partner_id: {
            type: [String, Number],
            default: ''
        },
    },
    data() {
        return {
            mapPickerVisible: false,
            shopLngLat: [116.397428, 39.90923],
            // 选中的地图信息
            selectedMapInfo: {
                adcode: "",
                city: "",
                cityCode: "",
                district: "",
                districtCode: "",
                formattedAddress: "",
                lat: "",
                lng: "",
                province: "",
                provinceCode: ""
            },
            freightList: [], // 运费模板列表
            goodsForm: {
                name: '', //商品名称
                categoryId: [],
                thumb: '', //商品封面图
                images: [], //商品轮播图
                body: '', //商品详情
                product_certificate: '',//商品凭证
                classification: '', //分类
                unit: '', //商品单位
                spec: [{
                    key_name: '', //名称
                    stock: '', //库存
                    min_buy_num: '', //起批量
                    shop_price: '', //单价
                    status: 1, //1=使用中 0=停用
                    id: '',
                }],
                delivery_address: '',//发货地
                freight_template_id: '', //运费模板id
                is_shipping: '1',// 1=免费 0=不包邮
            },
            spectypeid: '', // 商品规格类型id
            goodsFormRules: {
                name: [{ required: true, message: '请输入商品名称', trigger: 'blur' }],
                categoryId: [{ required: true, message: '请选择商品分类', trigger: 'change' }],
                thumb: [{ required: true, message: '请上传商品封面图', trigger: 'change' }],
                images: [{ required: true, message: '请上传商品轮播图', trigger: 'change' }],
                body: [{ required: true, message: '请输入商品详情', trigger: 'blur' }],
                product_certificate: [{ required: true, message: '请上传商品凭证', trigger: 'change' }],
                classification: [{ required: true, message: '请输入商品分类', trigger: 'blur' }],
                unit: [{ required: true, message: '请输入商品单位', trigger: 'blur' }],
                spec: [{ required: true, message: '请添加商品规格', trigger: 'change' }]
            },
            // 编辑器配置
            editorOptions: {
                placeholder: '请输入商品详情',
                theme: 'snow',
                modules: {
                    toolbar: [
                        ['bold', 'italic', 'underline', 'strike'], // 加粗, 斜体, 下划线, 删除线
                        ['blockquote', 'code-block'], // 引用, 代码块

                        [{ 'header': 1 }, { 'header': 2 }], // 标题，键值对的形式；1、2表示字体大小
                        [{ 'list': 'ordered' }, { 'list': 'bullet' }], // 列表
                        [{ 'script': 'sub' }, { 'script': 'super' }], // 上下标
                        [{ 'indent': '-1' }, { 'indent': '+1' }], // 缩进
                        [{ 'direction': 'rtl' }], // 文本方向

                        [{ 'size': ['small', false, 'large', 'huge'] }], // 字体大小
                        [{ 'header': [1, 2, 3, 4, 5, 6, false] }], // 标题

                        [{ 'color': [] }, { 'background': [] }], // 字体颜色，字体背景颜色
                        [{ 'font': [] }], // 字体
                        [{ 'align': [] }], // 对齐方式

                        ['clean'], // 清除格式
                        ['image', 'video'] // 图片、视频
                    ]
                }
            },
            cascaderData: [], // 商品分类树
            cascaderProps: {
                value: 'aid',
                label: 'name',
                children: 'children',
            },
        }
    },
    mounted() {
        this.getFreightList();
        this.getCategoryTree();
        this.initShopLngLat();
    },
    computed: {
        // 计算总库存
        computedTotalStock() {
            return this.goodsForm.spec.reduce((acc, cur) => {
                return acc + Number(cur.stock);
            }, 0);
        }
    },
    methods: {
        // 获取商品分类树
        getCategoryTree() {
            this.$api.getHomeShopFenlei().then(res => {
                res.forEach(item => {
                    if (item.children && item.children.length > 0) {
                        item.disabled = false;
                    } else {
                        item.disabled = true;
                    }
                })
                this.cascaderData = res;
                if (this.goods_id) {
                    this.getGoodsDetail();
                }
            }).catch(err => {
                this.$message.error(err.message);
            })
        },
        // 获取店铺经纬度，用于地图选点初始中心
        initShopLngLat() {
            this.$api.getShopInfo({ partner_id: this.partner_id }).then(res => {
                if (res && res.lng && res.lat) {
                    this.shopLngLat = [Number(res.lng), Number(res.lat)];
                }
            }).catch(() => {})
        },
        // 获取商品详情
        getGoodsDetail() {
            this.$api.getProductInfo({
                goods_id: this.goods_id,
                is_edit: '1',
            }).then(res => {
                this.spectypeid = res.spectypeid;
                this.goodsForm.categoryId = [res.parent_category_id, res.goodscategory_id];
                this.goodsForm.name = res.name;
                this.goodsForm.thumb = res.thumb;
                this.goodsForm.images = res.images;
                this.goodsForm.body = res.body;
                this.goodsForm.product_certificate = res.product_certificate;
                this.goodsForm.classification = res.classification;
                this.goodsForm.unit = res.unit;
                this.goodsForm.spec = res.sku_list;
                this.goodsForm.delivery_address = res.place_of_dispatch;
                this.goodsForm.is_shipping = String(res.is_shipping);
                this.goodsForm.freight_template_id = res.freight_template_id;
                this.selectedMapInfo = {
                    province: res.place_of_dispatch_province,
                    city: res.place_of_dispatch_city,
                    district: res.place_of_dispatch_district,
                    formattedAddress: res.place_of_dispatch_address,
                    lat: res.place_of_dispatch_lat,
                    lng: res.place_of_dispatch_lng,
                }
            }).catch(err => {
                this.$message.error(err.message);
            })
        },
        submitForm() {
            this.$refs.goodsForm.validate(valid => {
                if (valid) {
                    this.$api.addProduct({
                        partner_id: this.partner_id,
                        place_of_dispatch: this.goodsForm.delivery_address,
                        place_of_dispatch_province: this.selectedMapInfo.province,
                        place_of_dispatch_city: this.selectedMapInfo.city,
                        place_of_dispatch_district: this.selectedMapInfo.district,
                        place_of_dispatch_address: this.selectedMapInfo.formattedAddress,
                        place_of_dispatch_lat: this.selectedMapInfo.lat,
                        place_of_dispatch_lng: this.selectedMapInfo.lng,
                        is_shipping: this.goodsForm.is_shipping,
                        goodsfreight_id: this.goodsForm.freight_template_id,
                        unit: this.goodsForm.unit,
                        classification: this.goodsForm.classification,
                        name: this.goodsForm.name,
                        images: this.goodsForm.images.join(','),
                        body: this.goodsForm.body,
                        goodscategory_id: this.goodsForm.categoryId[1] || this.goodsForm.categoryId[0],
                        product_certificate: this.goodsForm.product_certificate,
                        is_sale: '0',
                        is_spec: '1',
                        stock: this.computedTotalStock,
                        goods_spec: this.goodsForm.spec,
                        id: this.goods_id || '',
                        thumb: this.goodsForm.thumb,
                        spectypeid: this.spectypeid,
                    }).then(res => {
                        this.$message.success('添加成功');
                        this.goBack();
                    }).catch(err => {
                        this.$message.error(err);
                    });
                } else {
                    console.log('校验失败');
                }
            });
        },
        // 处理地图选点确认
        handleMapConfirm(selectedInfo) {
            this.mapPickerVisible = false;
            this.goodsForm.delivery_address = selectedInfo.province + selectedInfo.city + selectedInfo.district + selectedInfo.formattedAddress;
            this.selectedMapInfo = selectedInfo;
        },
        // 处理地图选点弹窗关闭
        handleMapPickerClose() {
            this.mapPickerVisible = false;
        },
        // 添加规格行
        addSpecRow() {
            this.goodsForm.spec.push({
                key_name: "", //名称
                stock: "", //库存
                min_buy_num: "", //起批量
                shop_price: "", //单价
                status: 1, //1=使用中 0=停用
                id: "",
            });
        },
        moveDown(index) {
            const newList = [...this.goodsForm.spec];
            const temp = newList[index];
            newList[index] = newList[index + 1];
            newList[index + 1] = temp;
            this.goodsForm.spec = newList;
        },
        delFun(index) {
            if (this.goodsForm.spec.length <= 1) return this.$message.info('至少保留一个');
            this.goodsForm.spec.splice(index, 1);
        },
        handleImgUpload(type, imageUrl) {
            if (type === 1) {
                this.goodsForm.thumb = imageUrl[0];
            } else if (type === 2) {
                this.goodsForm.images = imageUrl;
            } else if (type === 3) {
                this.goodsForm.product_certificate = imageUrl[0];
            }
        },
        getFreightList() {
            this.$api.getFreightTemplateList({
                partner_id: this.partner_id
            }).then(res => {
                this.freightList = res;

            }).catch(err => {
                console.log(err);
            })
        },
        goBack() {
            this.$emit('goToComponent', 'ProductList');
        }
    }
}
</script>
<style scoped>
.page-header {
    margin-bottom: 20px;
}

/* .goods-form {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
} */

.goods_form-item {
    display: flex;
    width: 100%;
    gap: 10px;
}

.el-form-item {
    flex: 1 1 calc(50% - 10px);
    text-align: left;
    margin-bottom: 10px;
}
</style>